import { pick, truncate } from 'lodash';

import { strToBin } from '../utils';

const encodeErrorBundle = (
  errorBundle: Error & {
    id?: string;
    title?: string;
    code?: string;
    status?: number;
    step?: string;
  }
) => {
  const slimBundle = pick(errorBundle, 'id', 'title', 'code', 'status', 'step');
  slimBundle.title = truncate(slimBundle.title || '', { length: 250 });
  const jsonBundle = JSON.stringify(slimBundle);
  const binaryBundle = strToBin(jsonBundle);
  const base64Bundle = btoa(binaryBundle);
  return base64Bundle;
};

export default encodeErrorBundle;
